import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ProductModelNew} from "../../data/model/Product";

export interface ProductPageState {
    currentPage: number;
    categoryId?: string;
    producerId?: string;
    query?: string;
}

const initialState: ProductPageState = {
    currentPage: 1,
    categoryId: undefined,
    producerId: undefined,
    query: undefined,
};

export const productPageSlice = createSlice({
    name: 'productPage',
    initialState,
    reducers: {
        setProductCategoryId: (state, action: PayloadAction<string | undefined>) => {
            state.categoryId = action.payload;
        },
        setProductProducerId: (state, action: PayloadAction<string | undefined>) => {
            state.producerId = action.payload;
        },
        setProductQuery: (state, action: PayloadAction<string | undefined>) => {
            state.query = action.payload;
        },
        setProductPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        productCancelFilters: (state) => {
            // state = {
            //     query: undefined,
            //     producerId: undefined,
            //     categoryId: undefined,
            //     currentPage: 1,
            // }
            state.categoryId = undefined;
            state.producerId = undefined;
            state.query = undefined;
            state.currentPage = 1;
        }
    },
});

export const {
    setProductCategoryId,
    setProductProducerId,
    setProductQuery,
    setProductPage,
    productCancelFilters
} = productPageSlice.actions;

export default productPageSlice.reducer;
